
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { ShoppingBag } from 'lucide-react';

interface ShopifyIntegrationSettingsProps {
  initialConnected?: boolean;
  onSaved: () => Promise<void>;
}

const ShopifyIntegrationSettings: React.FC<ShopifyIntegrationSettingsProps> = ({ 
  initialConnected = false,
  onSaved 
}) => {
  const [isConnected, setIsConnected] = useState(initialConnected);
  const [shopUrl, setShopUrl] = useState('');
  const [apiKey, setApiKey] = useState('');

  const handleConnect = async () => {
    // Implement Shopify connection logic
    await onSaved();
    setIsConnected(true);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <ShoppingBag className="mr-2 h-6 w-6" />
          Shopify Integration
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <Label>Shopify Connection</Label>
            <Switch 
              checked={isConnected}
              onCheckedChange={setIsConnected}
            />
          </div>

          {isConnected ? (
            <div className="space-y-4">
              <div>
                <Label>Shop URL</Label>
                <Input 
                  value={shopUrl}
                  onChange={(e) => setShopUrl(e.target.value)}
                  placeholder="https://your-store.myshopify.com"
                />
              </div>
              <div>
                <Label>API Key</Label>
                <Input 
                  type="password"
                  value={apiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                  placeholder="Enter Shopify API Key"
                />
              </div>
              <Button onClick={handleConnect}>
                Update Connection
              </Button>
            </div>
          ) : (
            <Button onClick={handleConnect} className="w-full">
              Connect to Shopify
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ShopifyIntegrationSettings;
